import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { LoginStatus } from '@ndvr/auth-api';

import { setImpersonatedUser } from '@/components/ImpersonationBanner';
import { AuthApi } from 'API';
import { ErrorBox } from 'widgets';

import { AuthenticationPage } from './AuthenticationPage';

export const LoginWithToken = () => {
    const navigate = useNavigate();
    const { loginToken } = useParams();
    const [searchParams] = useSearchParams();
    const [submitError, setSubmitError] = useState('');

    useEffect(() => {
        const loginWithToken = async () => {
            try {
                if (!loginToken) {
                    navigate('/login');
                    return;
                }

                const [response] = await AuthApi().loginWithToken(loginToken);
                if (!response || response.loginResponse.status === LoginStatus.UNVERIFIED) {
                    setSubmitError('Failed to log in with token!');
                    return;
                }

                const personOrgGUID = response.loginResponse.personOrgGUID;

                // Check query parameter to determine if this is an impersonation login
                const isImpersonation = searchParams.get('impersonation') === 'true';
                if (isImpersonation) {
                    setImpersonatedUser(personOrgGUID);
                }

                // Full page load instead of SPA navigation: the session cookie just changed,
                // and any render under the previous in-memory identity would fire requests
                // as the previous user (and trip the AuthProvider identity-change reload,
                // causing a visible double reload).
                window.location.assign('/');
            } catch (error) {
                setSubmitError('Failed to log in with token!');
            }
        };

        loginWithToken();
    }, [loginToken]); // eslint-disable-line react-hooks/exhaustive-deps

    if (submitError) {
        return (
            <AuthenticationPage>
                <ErrorBox>{submitError}</ErrorBox>
            </AuthenticationPage>
        );
    }

    return <AuthenticationPage>Logging in...</AuthenticationPage>;
};
